module.exports = __webpack_public_path__ + "assets/img/f7a8314fce49a2ec338f4afcf04ec412.png";